import { defineComponent as _defineComponent } from 'vue'
import BaseText from '@ui/atoms/baseText/BaseText.vue';

  const __default__ = {
    name: 'EmptyState',
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

  
return { __sfc: true,BaseText }
}

})